module.exports = __webpack_public_path__ + "img/hemispheric-congress.cde39015.png";